import { useFormik } from "formik";
import { JsonParam, useQueryParam } from "use-query-params";
import Drawer from "../../../../common/Drawer";
import { mapCustomerFilterToQueryParams } from "../../../../interfaces/customer";
import Messages from "../../../../languages/Messages";
import CustomerFilterForm from "../../share/CustomerFilterForm";

interface ICustomerTableFilterDrawerProps {
    open: boolean;
    onClose: () => void;
}

const CustomerTableFilterDrawer = ({
    open,
    onClose,
}: ICustomerTableFilterDrawerProps) => {
    const [filter, setFilter] = useQueryParam<any>("filter", JsonParam);
    const filterForm = useFormik<any>({
        initialValues: filter ?? ({} as any),
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values: any) => {
            const params = mapCustomerFilterToQueryParams(values);
            setFilter(params);
            onClose();
        },
    });

    return (
        <Drawer
            open={open}
            size="x-large"
            onClose={onClose}
            title={Messages.filter}
            onSave={() => filterForm?.handleSubmit()}
            cancelText={Messages.clearAll}
            cancelButtonProps={{
                color: "error",
                onClick: () => {
                    filterForm.setValues({});
                },
            }}
        >
            <CustomerFilterForm filterForm={filterForm} />
        </Drawer>
    );
};

export default CustomerTableFilterDrawer;
